import { useContext } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { AppBar, Box, Button, IconButton, Tab, Tabs, Toolbar } from '@mui/material'
import * as Icons from '@mui/icons-material'
import useMediaQuery from '@mui/material/useMediaQuery'
import logo from '../assets/appbar-logo.png'
import wordmark from '../assets/appbar-wordmark.png'
import { BRAND_PRIMARY } from '~/styles/palette'
import { ThemeContext } from '~/common/context/theme/theme-context'
import { APPBAR_HEIGHT_REM, APPBAR_EXTRA_DESKTOP_REM, DESKTOP_BREAKPOINT } from '~/common/constants/layout-constants'
import theme from '~/styles/mui-theme'

const NAV_TABS = [
  { label: 'About', path: '/about' },
  { label: 'Support Us', path: '/support' },
]

export const MarketingAppbar = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { mode, setMode } = useContext(ThemeContext)
  const isDesktop = useMediaQuery(theme.breakpoints.up(DESKTOP_BREAKPOINT))

  const handleThemeCycle = () => {
    const modes = ['light', 'dark', 'system']
    const currentIndex = modes.indexOf(mode)
    setMode(modes[(currentIndex + 1) % modes.length])
  }

  const activeTab = NAV_TABS.findIndex(t => t.path === location.pathname)

  return (
    <AppBar
      position="fixed"
      color="primary"
      sx={{
        zIndex: (t) => t.zIndex.drawer + 1,
        '& .MuiToolbar-gutters': { p: '0 0.5rem' },
        height: isDesktop ? APPBAR_HEIGHT_REM : `calc(${APPBAR_HEIGHT_REM} - ${APPBAR_EXTRA_DESKTOP_REM})`,
        backgroundColor: BRAND_PRIMARY,
      }}
    >
      <Toolbar sx={{ gap: 1 }}>
        <Box
          sx={{
            p: 0.5,
            mr: 1,
            borderRadius: 1,
            cursor: 'pointer',
            transition: 'background-color 0.2s',
            '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' },
          }}
          onClick={() => navigate('/')}
        >
          <Box
            component="img"
            src={isDesktop ? wordmark : logo}
            alt="TerraPlanner"
            width={200}
            height={50}
            sx={{ height: isDesktop ? 50 : 40, width: 'auto', display: 'block' }}
          />
        </Box>

        <Box sx={{ flexGrow: 1 }} />

        <Tabs
          value={activeTab === -1 ? false : activeTab}
          textColor="inherit"
          slotProps={{ indicator: { style: { backgroundColor: 'rgba(255,255,255,0.8)' } } }}
          sx={{ minHeight: 0 }}
        >
          {NAV_TABS.map((tab) => (
            <Tab
              key={tab.path}
              label={tab.label}
              onClick={() => navigate(tab.path)}
              sx={{
                ...isDesktop ? {
                  mx: 0.5,
                } : {
                  minWidth: '70px',
                  px: 0.25,
                },
                color: 'inherit',
                opacity: 0.85,
                minHeight: 0,
                py: 1,
                fontSize: '0.875rem',
                '&.Mui-selected': { opacity: 1 },
              }}
            />
          ))}
        </Tabs>

        <IconButton
          color="inherit"
          onClick={handleThemeCycle}
          aria-label="toggle theme"
          sx={{ ml: 1 }}
        >
          {mode === 'light' && <Icons.LightMode />}
          {mode === 'dark' && <Icons.DarkMode />}
          {mode === 'system' && <Icons.SettingsBrightness />}
        </IconButton>

        <Button
          variant="outlined"
          color="inherit"
          size="small"
          onClick={() => navigate('/login')}
          sx={{
            minWidth: '70px',
            borderColor: 'rgba(255,255,255,0.6)',
            '&:hover': {
              borderColor: '#fff',
              bgcolor: 'rgba(255,255,255,0.1)'
            }
          }}
        >
          Log in
        </Button>
      </Toolbar>
    </AppBar>
  )
}
